const ar = {
  nav: {
    groups: { overview: 'نظرة عامة', business: 'الأعمال', recruitment: 'التوظيف', management: 'الإدارة', platform: 'المنصة', intelligence: 'المساعد الذكي' },
    dashboard: 'لوحة التحكم', ateliers: 'الأتيليهات', subscriptions: 'الاشتراكات', order_plans: 'طلبات الباقات',
    demo_tenants: 'الحسابات التجريبية',
    expired_demo_tenants: 'الحسابات التجريبية المنتهية',
    plans: 'الباقات',
    payments: 'المدفوعات', payment_gateways: 'بوابات الدفع', users: 'المستخدمون', admin_roles: 'أدوار المسؤولين', settings: 'الإعدادات',
    feature_flags: 'إعدادات الميزات', support: 'الدعم الفني', notifications: 'الإشعارات',
    messages: 'الرسائل',
    recruitment_jobs: 'الوظائف',
    recruitment_applications: 'طلبات التوظيف',
    recruitment_settings: 'إعدادات التوظيف',
    logs: 'السجلات', integrations: 'التكاملات',     marketing: 'التسويق', releases: 'إدارة الإصدارات',
    intel_command: 'مركز القيادة',
    intel_conversations: 'المحادثات',
    intel_leads: 'العملاء المحتملون',
    intel_followups: 'المتابعات',
    sign_out: 'تسجيل الخروج',
  },
  admin: { role: 'مسؤول عام' },
  page: {
    dashboard:         { title: 'لوحة التحكم',         subtitle: 'مرحباً بعودتك، المسؤول العام' },
    ateliers:          { title: 'الأتيليهات',           subtitle: 'إدارة جميع الأتيليهات المسجلة' },
    subscriptions:     { title: 'الاشتراكات',           subtitle: 'متابعة جميع الاشتراكات النشطة' },
    order_plans:       { title: 'طلبات الباقات',        subtitle: 'مراجعة طلبات شراء الباقات والموافقة عليها' },
    demo_tenants:      { title: 'الحسابات التجريبية',   subtitle: 'إنشاء تينانت ديمو بدون باقة لمدة 1–7 أيام' },
    expired_demo_tenants: { title: 'الحسابات التجريبية المنتهية', subtitle: 'الحسابات التجريبية التي انتهت مدتها' },
    plans:             { title: 'الباقات',              subtitle: 'إدارة باقات الأسعار والميزات' },
    payments:          { title: 'المدفوعات',            subtitle: 'تتبع جميع المعاملات المالية' },
    payment_gateways:  { title: 'بوابات الدفع',         subtitle: 'إدارة طرق الدفع اليدوية' },
    users:             { title: 'المستخدمون',           subtitle: 'إدارة أعضاء فريق المسؤولين' },
    admin_roles:       { title: 'أدوار المسؤولين',      subtitle: 'تكوين الأدوار والصلاحيات' },
    settings:          { title: 'الإعدادات',            subtitle: 'إعداد النظام الشامل' },
    feature_flags:     { title: 'إعدادات الميزات',      subtitle: 'تفعيل وإيقاف الميزات حسب الباقة' },
    support:           { title: 'الدعم الفني',          subtitle: 'إدارة تذاكر الدعم الفني' },
    notifications:     { title: 'الإشعارات',            subtitle: 'إرسال إشعارات جماعية' },
    messages:          { title: 'الرسائل',              subtitle: 'رسائل نموذج التواصل من الصفحة الرئيسية' },
    recruitment_jobs:  { title: 'الوظائف',              subtitle: 'إنشاء ونشر وأرشفة الوظائف المفتوحة' },
    recruitment_applications: { title: 'طلبات التوظيف', subtitle: 'مراجعة المرشحين ومسار التوظيف' },
    recruitment_settings: { title: 'إعدادات التوظيف',   subtitle: 'استقبال الطلبات وتنبيهات الفريق' },
    profile:           { title: 'ملفي الشخصي',          subtitle: 'إدارة بيانات الحساب وكلمة المرور' },
    logs:              { title: 'السجلات',              subtitle: 'سجلات نشاط النظام' },
    integrations:      { title: 'التكاملات',            subtitle: 'خدمات الطرف الثالث' },
    marketing:         { title: 'التسويق',              subtitle: 'الكوبونات والإحالات والحملات' },
    intelligence:      { title: 'المساعد الذكي',        subtitle: 'مركز قيادة المحادثات والعملاء والمتابعات' },
    demo_tenant_performance: { title: 'أداء الحساب التجريبي', subtitle: 'رحلة التجربة والتفاعل وإشارات الشراء' },
  },
  topbar: { search_placeholder: 'ابحث عن أي شيء...', my_profile: 'ملفي الشخصي', sign_out: 'تسجيل الخروج' },
  stats: {
    total_revenue: 'إجمالي الإيرادات', active_subscriptions: 'الاشتراكات النشطة',
    new_ateliers: 'أتيليهات جديدة', churn_rate: 'معدل الإلغاء', vs_last_month: 'مقارنة بالشهر الماضي',
  },
  chart: {
    revenue: { title: 'نمو الإيرادات', subtitle: 'اتجاه الإيرادات الشهرية', monthly: 'شهري', yearly: 'سنوي' },
    growth:  { title: 'نمو الأتيليهات', subtitle: 'الجديدة مقابل الملغاة', new_ateliers: 'أتيليهات جديدة', churned: 'ملغاة' },
  },
  recent: {
    subscriptions: { title: 'آخر الاشتراكات', subtitle: 'أحدث التسجيلات',  view_all:  'عرض الكل' },
    activities:    { title: 'النشاط الأخير',   subtitle: 'سجل النشاط العام', view_logs: 'عرض السجلات' },
  },
  table: {
    showing: 'عرض', of: 'من',
    no_ateliers: 'لا توجد أتيليهات', no_subscriptions: 'لا توجد اشتراكات', no_order_plans: 'لا توجد طلبات باقات بعد',
    ateliers_count: 'أتيليه', subscriptions_count: 'اشتراك', order_plans_count: 'طلب',
  },
  plan_tiers: {
    basic: 'أساسية',
    professional: 'احترافية',
    enterprise: 'مؤسسات',
    starter: 'ستارتر',
    pro: 'برو',
  },
  ateliers: {
    filter: { all: 'الكل', active: 'نشط', suspended: 'موقوف', pending: 'معلق', trial: 'تجريبي' },
    search_placeholder: 'ابحث عن أتيليه...', add_atelier: 'إضافة أتيليه',
    loading: 'جاري تحميل الأتيليهات…',
    prefer_order_plans_banner: 'المسار المفضّل لتفعيل عميل جديد: راجع طلبات الباقات أولاً.',
    go_order_plans: 'فتح طلبات الباقات',
    col: {
      atelier: 'الأتيليه',
      phone: 'الجوال',
      domain: 'النطاق',
      storefront: 'واجهة المتجر',
      workspace: 'مساحة العمل',
      open_login: 'الدخول للتينانت',
      created_by: 'أنشأه',
      plan: 'الباقة',
      status: 'الحالة',
      employees: 'الموظفون',
      created: 'تاريخ الإنشاء',
      actions: 'الإجراءات',
    },
    login_as_loading: 'جارٍ الدخول…',
    login_as_failed: 'تعذر الدخول للتينانت',
    modal: {
      title: 'تفاصيل الأتيليه',
      edit: 'تعديل الأتيليه',
      login_as: 'الدخول كأتيليه',
      tenant_id: 'معرّف المستأجر',
      workspace: 'معرّف مساحة العمل',
      login_url: 'رابط تسجيل الدخول',
      login_url_hint: 'استخدم زر الدخول كأتيليه لفتح لوحة التينانت مباشرة بصلاحيات المدير.',
      created_by: 'أنشأه الأدمن',
      employees: 'الموظفون',
      branches: 'الفروع',
      phone: 'الهاتف',
      created: 'تاريخ الإنشاء',
      updated: 'آخر تحديث',
      renewal: 'تاريخ التجديد',
      plan: 'الباقة',
      change_plan: 'تغيير الباقة',
      save_plan: 'حفظ الباقة',
      trial_ends: 'انتهاء التجربة',
      db_name: 'قاعدة بيانات المستأجر',
      monthly_revenue: 'الإيراد الشهري',
      free_trial: 'تجربة مجانية',
      add_domain: 'إضافة نطاق',
      domain_placeholder: 'مثال: ahmad-alias',
      domain_submit: 'إضافة',
      domain_required: 'أدخل معرف النطاق (slug).',
      domain_delete: 'حذف النطاق',
      migrate: 'ترحيل قاعدة البيانات',
      seed: 'تشغيل السيدر',
      delete_tenant: 'حذف الأتيليه',
      delete_confirm_title: 'تأكيد حذف الأتيليه',
      delete_tenant_confirm:
        'أنت على وشك حذف "{{name}}" نهائياً. ستُزال جميع البيانات المرتبطة بهذا المستأجر. لا يمكن التراجع عن هذا الإجراء.',
      delete_confirm_action: 'حذف نهائياً',
    },
    custom_plan: {
      option: 'Custom Plan',
      title: 'باقة مخصصة لهذا المستأجر',
      hint: 'هذه الباقة خاصة بهذا الأتيليه فقط ولن تظهر في كتالوج الباقات العامة.',
      monthly_price: 'السعر الشهري',
      yearly_price: 'السعر السنوي',
      interval: 'نوع الاشتراك',
      monthly: 'شهري',
      yearly: 'سنوي',
      currency: 'العملة',
      starts_at: 'تاريخ بداية الاشتراك',
      duration: 'مدة الاشتراك',
      duration_monthly: 'شهر واحد من تاريخ البداية',
      duration_yearly: 'سنة واحدة من تاريخ البداية',
      ends_at: 'تاريخ الانتهاء',
      features: 'المزايا وحدود الاستخدام',
      required: 'يرجى إدخال السعر الشهري والسنوي وتاريخ البداية للباقة المخصصة.',
    },
    create: {
      title: 'إضافة أتيليه (مستأجر)',
      cancel: 'إلغاء',
      submit: 'إنشاء',
      submitting: 'جاري الإنشاء…',
      provisioning_missing_tenant_id:
        'تم إنشاء الأتيليه لكن فشلت تهيئته تلقائيًا (معرّف المستأجر غير موجود).',
      fields: {
        name: 'اسم الشركة / الأتيليه',
        plan: 'الباقة',
        email: 'بريد المدير',
        password: 'كلمة مرور المدير',
        phone: 'الجوال (اختياري)',
      },
      plan_required: 'يرجى اختيار باقة للمستأجر.',
      loading_plans: 'جاري تحميل الباقات…',
      prefer_order_plans: 'المسار المفضّل للعملاء الجدد هو مراجعة طلب باقة وارد.',
      go_order_plans: 'الانتقال لطلبات الباقات',
    },
    edit: {
      title: 'تعديل الأتيليه',
      name: 'الاسم',
      plan: 'الباقة',
      submit: 'حفظ',
      submitting: 'جاري الحفظ…',
    },
  },
  subscriptions: {
    loading: 'جارٍ تحميل الاشتراكات…',
    summary: {
      total: 'إجمالي الاشتراكات',
      active: 'نشط',
      pending: 'معلق',
      expired: 'منتهي الصلاحية',
      mrr: 'الإيراد الشهري (MRR)',
      page_scope: 'هذه الصفحة',
    },
    search_on_page: '{{count}} نتيجة في هذه الصفحة',
    filter: {
      all: 'الكل',
      active: 'نشط',
      pending: 'معلق',
      rejected: 'مرفوض',
      cancelled: 'ملغي',
      trial: 'تجريبي',
      expired: 'منتهي',
    },
    search_placeholder: 'ابحث عن اشتراك...',
    col: {
      id: 'الرقم',
      atelier: 'الأتيليه',
      tenant: 'المستأجر',
      plan: 'الباقة',
      price: 'السعر',
      status: 'الحالة',
      renewal_date: 'تاريخ التجديد',
      ends_at: 'ينتهي في',
      starts_at: 'يبدأ في',
      last_payment: 'آخر دفعة',
      actions: 'الإجراءات',
    },
    detail: {
      title: 'تفاصيل الاشتراك',
      status: 'الحالة',
      payments: 'المدفوعات',
      no_payments: 'لا توجد مدفوعات مسجلة.',
      payments_table: {
        id: 'الرقم',
        plan: 'الباقة',
        price: 'المبلغ',
        paid_at: 'تاريخ الدفع',
        period: 'فترة التغطية',
        status: 'الحالة',
      },
      save_status: 'تطبيق الحالة',
      saving: 'جارٍ الحفظ…',
    },
    expired: 'منتهي الصلاحية',
    free_trial: 'تجربة مجانية', monthly: 'شهري', yearly: 'سنوي',
  },
  demo_tenants: {
    add: 'إنشاء حساب تجريبي',
    loading: 'جارٍ تحميل الحسابات التجريبية…',
    empty: 'لا توجد حسابات تجريبية بعد',
    banner: 'الحساب التجريبي بدون باقة، وينتهي تلقائياً بعد المدة المحددة مع إشعار للمستخدم.',
    search_placeholder: 'ابحث بالاسم أو البريد…',
    open_login: 'الدخول للتينانت',
    view_performance: 'عرض الأداء',
    days_left: '{{count}} يوم متبقي',
    days_label: '{{days}} أيام',
    filter: {
      all: 'الكل',
      active: 'نشط',
      expired: 'منتهٍ',
      suspended: 'موقوف',
    },
    summary: {
      total: 'إجمالي التجارب',
      active: 'نشطة',
      expired: 'منتهية',
      suspended: 'موقوف',
    },
    col: {
      name: 'الحساب',
      email: 'البريد',
      created_by: 'أنشأه الأدمن',
      days: 'المدة',
      remaining: 'المتبقي',
      ends_at: 'ينتهي في',
      status: 'الحالة',
      created: 'وقت الإنشاء',
      actions: 'الإجراءات',
    },
    create: {
      title: 'إنشاء حساب ديمو تجريبي',
      hint: 'لن يُربط بباقة. اختر مدة من 1 إلى 7 أيام، وبعدها ينتهي التفعيل تلقائياً.',
      cancel: 'إلغاء',
      submit: 'إنشاء الحساب',
      submitting: 'جارٍ الإنشاء…',
      days_help: 'المدة المختارة: {{days}} يوم/أيام',
      fields: {
        name: 'اسم الأتيليه / الشركة',
        email: 'بريد المدير',
        password: 'كلمة مرور المدير',
        phone: 'الجوال (اختياري)',
        days: 'مدة التجربة (أيام)',
      },
    },
    performance: {
      back: 'العودة للحسابات التجريبية',
      title: 'أداء الحساب التجريبي',
      started: 'بداية التجربة',
      last_active: 'آخر نشاط',
      duration: 'مدة التجربة',
      duration_days: '{{count}} يوم',
      onboarding: 'رحلة التجهيز',
      health: 'صحة التجربة',
      summary: 'ملخص الأداء',
      journey: 'خطوات التجهيز',
      activity: 'النشاط',
      last_action: 'آخر إجراء',
      engagement: 'مستوى التفاعل',
      activation: 'تفعيل الحساب',
      signals: 'إشارات الشراء',
      recommendation: 'التوصية',
      pricing: 'الباقات والترقية',
      lifecycle: 'مراحل التجربة',
      priority: 'أولوية المتابعة',
      why: 'سبب هذه النتيجة',
      metrics: 'مؤشرات التشغيل',
      load_more: 'تحميل المزيد',
      empty_activity: 'لا يوجد نشاط بعد',
      none: 'لم تتم بعد',
      filters: {
        type: 'نوع النشاط',
        period: 'الفترة',
        all: 'الكل',
        onboarding: 'التجهيز',
        customers: 'العملاء',
        reservations: 'الحجوزات',
        inventory: 'المخزون',
        purchases: 'المشتريات',
        accounts: 'الحسابات',
        system: 'النظام',
        today: 'اليوم',
        last_3_days: 'آخر 3 أيام',
        last_7_days: 'آخر 7 أيام',
        all_activity: 'كل النشاط',
      },
      status: {
        active: 'نشط',
        expired: 'منتهٍ',
        converted: 'محوّل لاشتراك',
        suspended: 'موقوف',
      },
      health_band: {
        highly_engaged: 'تفاعل مرتفع جدًا',
        engaged: 'متفاعل',
        exploring: 'يستكشف',
        idle: 'خامل',
      },
      engagement_level: {
        hot: 'قوي',
        warm: 'متوسط',
        cold: 'ضعيف',
        inactive: 'غير نشط',
      },
      activation_status: {
        not_activated: 'لم يُفعَّل بعد',
        partially_activated: 'تفعيل جزئي',
        activated: 'مفعّل',
        fully_activated: 'مفعّل بالكامل',
      },
      priority_level: {
        high: 'مرتفعة',
        medium: 'متوسطة',
        low: 'منخفضة',
      },
      pricing_keys: {
        pricing_viewed: 'اطّلع على الباقات',
        upgrade_clicked: 'ضغط على الترقية',
        checkout_started: 'بدأ طلب الاشتراك',
        payment: 'تم الدفع',
      },
      metrics_keys: {
        customers: 'العملاء',
        reservations: 'الحجوزات',
        products: 'المنتجات',
        purchase_orders: 'طلبيات الشراء',
        received_orders: 'طلبيات مستلمة',
        inventory_items: 'عناصر المخزون',
        financial_activities: 'الحركات المالية',
        onboarding: 'خطوات التجهيز',
      },
      lifecycle_stage: {
        created: 'تم إنشاء الحساب',
        started: 'بدأت الرحلة',
        activated: 'تم التفعيل',
        engaged: 'بدأ الاستخدام',
        upgrade_intent: 'أبدى رغبة في الترقية',
        converted: 'تحوّل لاشتراك',
        expired: 'انتهت التجربة',
      },
    },
  },
  expired_demo_tenants: {
    loading: 'جارٍ تحميل الحسابات التجريبية المنتهية…',
    empty: 'لا توجد حسابات تجريبية منتهية',
    banner: 'الحسابات التجريبية التي انتهت مدتها تُنقل تلقائياً إلى هنا.',
    summary: {
      total: 'إجمالي المنتهية',
      expired: 'منتهية',
      suspended: 'موقوف',
    },
  },
  order_plans: {
    loading: 'جارٍ تحميل طلبات الباقات…',
    summary: {
      total: 'إجمالي طلبات الباقات',
      awaiting: 'بانتظار المراجعة',
      approved: 'موافق',
      rejected: 'مرفوض',
      page_scope: 'هذه الصفحة',
    },
    search_on_page: '{{count}} نتيجة في هذه الصفحة',
    search_placeholder: 'ابحث بالاسم أو البريد أو مساحة العمل…',
    filter: {
      all: 'الكل',
      awaiting_review: 'بانتظار المراجعة',
      pending: 'معلق',
      approved: 'موافق',
      rejected: 'مرفوض',
    },
    col: {
      id: 'الرقم',
      name: 'العميل',
      phone: 'الهاتف',
      plan: 'الباقة',
      price: 'السعر',
      tenant_id: 'مساحة العمل',
      subscription_id: 'الاشتراك',
      status: 'الحالة',
      created_at: 'تاريخ الإنشاء',
      updated_at: 'آخر تحديث',
      actions: 'الإجراءات',
    },
    detail: {
      title: 'تفاصيل طلب الباقة',
      customer: 'العميل',
      plan_section: 'الباقة المطلوبة',
      payment_section: 'إثبات الدفع',
      payment_reference: 'رقم الدفع',
      payment_submitted_at: 'تاريخ الإرسال',
      payment_proof: 'عرض صورة إيصال التحويل',
      payment_hint: 'تأكد من استلام التحويل قبل الموافقة على الطلب وتفعيل الاشتراك.',
      status: 'القرار',
      save_status: 'تطبيق الحالة',
      saving: 'جارٍ الحفظ…',
      approve: 'موافقة وتفعيل',
      reject: 'رفض الطلب',
      confirm_approve: 'تأكيد الموافقة وتفعيل الحساب؟ سيتم إرسال بيانات الدخول للعميل بالبريد.',
      confirm_reject: 'تأكيد رفض هذا الطلب؟',
      review_first: 'افتح التفاصيل لمراجعة إثبات الدفع ثم وافق أو ارفض من هنا.',
      next_steps: 'الخطوات التالية',
      open_atelier: 'فتح الأتيليه',
      open_subscription: 'فتح الاشتراك',
      open_payments: 'فتح المدفوعات',
    },
  },
  plans: {
    add_plan: 'إضافة باقة', edit_plan: 'تعديل الباقة', delete_plan: 'حذف الباقة',
    loading: 'جارٍ تحميل الباقات…',
    most_popular: 'الأكثر شعبية', active_subscribers: 'المشتركون النشطون',
    monthly: 'شهري', yearly: 'سنوي',
    max_employees: 'الحد الأقصى للموظفين', max_branches: 'الحد الأقصى للفروع', max_invoices: 'الحد الأقصى للفواتير',
    max_invoices_sale: 'فواتير البيع', max_invoices_rent: 'فواتير الإيجار', max_invoices_tailoring: 'فواتير التفصيل',
    max_assistant_messages: 'رسائل المساعد الذكي',
    features: 'المميزات', unlimited: 'غير محدود', limits: 'الحدود', currency: 'العملة',
    plan_active: 'نشط', plan_inactive: 'غير نشط',
    duration_days: 'يوماً',
    price_once: 'للمرة الواحدة',
    description_heading: 'الوصف',
    confirm_delete: 'هل أنت متأكد من حذف هذه الباقة؟ لا يمكن التراجع عن هذا الإجراء.',
    no_plans: 'لا توجد باقات',
    prev_page: 'السابق',
    next_page: 'التالي',
    summary: {
      total: 'إجمالي الباقات',
      active: 'باقات نشطة',
      inactive: 'باقات غير نشطة',
      subscribers: 'إجمالي المشتركين',
    },
    form: {
      title_add: 'إضافة باقة جديدة', title_edit: 'تعديل الباقة',
      title_label: 'العنوان',
      title_placeholder: 'مثال: أساسية',
      description: 'الوصف',
      description_placeholder: 'تفاصيل الباقة…',
      days: 'مدة الاشتراك (بالأيام)',
      days_placeholder: '365',
      days_help: 'عدد أيام صلاحية الاشتراك لكل أتيليه عند تفعيل/تجديد هذه الباقة.',
      price: 'السعر الأساسي',
      price_placeholder: '100',
      base_price_legacy: 'وراثي',
      base_price_help: 'السعر الأساسي - يُستخدم كاحتياطي إذا لم يُحدد سعر شهري/سنوي',
      name: 'اسم الباقة', name_placeholder: 'مثال: برو',
      monthly_price: 'السعر الشهري', yearly_price: 'السعر السنوي',
      yearly_discount: 'خصم الاشتراك السنوي (%)',
      currency: 'العملة',
      employees_label: 'الحد الأقصى للموظفين', branches_label: 'الحد الأقصى للفروع',
      invoices_label: 'الحد الأقصى للفواتير',
      limits_title: 'حدود الباقة',
      billing_cycle: 'دورة الفوترة',
      features_label: 'المميزات والحدود', features_placeholder: 'اكتب ميزة واضغط Enter',
      active_label: 'الباقة نشطة', save: 'حفظ الباقة', saving: 'جارٍ الحفظ…', cancel: 'إلغاء',
    },
  },
  payments: {
    view_invoice: 'عرض الفاتورة', refund: 'استرجاع', mark_paid: 'تحديد كمدفوع',
    confirm_refund: 'هل أنت متأكد من استرجاع هذه الدفعة؟ لا يمكن التراجع عن هذا الإجراء.',
    confirm_mark_paid: 'تحديد هذه الدفعة كمدفوعة؟',
    filter: { all: 'الكل', paid: 'مدفوع', pending: 'معلق', refunded: 'مسترجع', failed: 'فاشل' },
    search_placeholder: 'ابحث عن فاتورة...',
    col: { invoice: 'الفاتورة', atelier: 'الأتيليه', amount: 'المبلغ', method: 'طريقة الدفع', status: 'الحالة', date: 'التاريخ', actions: 'الإجراءات' },
    no_payments: 'لا توجد مدفوعات', payments_count: 'دفعة',
    method: { visa: 'فيزا', mada: 'مدى', stc: 'STC Pay', bank: 'تحويل بنكي', cash: 'نقدي' },
    summary: { total_revenue: 'إجمالي الإيرادات', paid: 'فواتير مدفوعة', pending: 'معلقة', refunded: 'مسترجعة' },
    invoice_modal: {
      title: 'تفاصيل الفاتورة', invoice_to: 'فاتورة إلى',
      issued_date: 'تاريخ الإصدار', due_date: 'تاريخ الاستحقاق',
      plan: 'الباقة', billing_cycle: 'دورة الفوترة',
      subtotal: 'المجموع الجزئي', tax: 'ضريبة القيمة المضافة (15%)', total: 'الإجمالي',
      print: 'طباعة', close: 'إغلاق',
    },
  },
  settings: {
    tabs: { general: 'عام', landing: 'الصفحة الرئيسية', email: 'البريد', payment: 'الدفع', sms: 'الرسائل' },
    save: 'حفظ التغييرات', saved: 'تم حفظ الإعدادات بنجاح!', test: 'إرسال اختبار',
    unsaved: 'توجد تغييرات غير محفوظة',
    general: {
      title: 'الإعدادات العامة', subtitle: 'إعداد المنصة الأساسي',
      platform_name: 'اسم المنصة', platform_name_desc: 'يظهر في رسائل البريد والإشعارات',
      support_email: 'بريد الدعم الفني', support_email_desc: 'بريد التواصل الرئيسي للمستخدمين',
      currency: 'العملة الافتراضية',
      timezone: 'المنطقة الزمنية',
      trial_days: 'مدة التجربة المجانية (أيام)', trial_days_desc: 'عدد أيام التجربة للمستخدمين الجدد',
      logo_url: 'رابط الشعار', logo_url_desc: 'رابط شعار المنصة',
      maintenance_mode: 'وضع الصيانة', maintenance_desc: 'تعطيل الوصول مؤقتاً لجميع الأتيليهات',
      password_section_title: 'تغيير كلمة المرور',
      password_section_subtitle: 'تحديث كلمة مرور حساب المسؤول',
      current_password: 'كلمة المرور الحالية',
      new_password: 'كلمة المرور الجديدة',
      confirm_password: 'تأكيد كلمة المرور الجديدة',
      update_password: 'تحديث كلمة المرور',
      password_updating: 'جاري التحديث…',
      password_success: 'تم تحديث كلمة المرور بنجاح.',
      password_mismatch: 'كلمة المرور الجديدة وتأكيدها غير متطابقتين.',
      password_fill_all: 'يرجى تعبئة جميع حقول كلمة المرور.',
    },
    email: {
      title: 'إعدادات البريد', subtitle: 'إعداد SMTP والإشعارات',
      smtp_host: 'خادم SMTP', smtp_port: 'منفذ SMTP',
      smtp_user: 'اسم مستخدم SMTP', smtp_pass: 'كلمة مرور SMTP',
      from_name: 'اسم المرسل', from_email: 'بريد المرسل',
      enable_notifications: 'تفعيل إشعارات البريد',
      enable_desc: 'إرسال بريد تلقائي للتسجيل والتجديد والإلغاء',
    },
    payment: {
      title: 'إعدادات الدفع', subtitle: 'إعداد بوابة الدفع والفوترة',
      gateway: 'بوابة الدفع', api_key: 'مفتاح API', api_key_desc: 'مفتاح بوابة الدفع السري',
      webhook_secret: 'مفتاح Webhook', webhook_desc: 'يُستخدم للتحقق من ردود الدفع',
      vat_rate: 'نسبة ضريبة القيمة المضافة (%)', vat_desc: 'تُطبق على جميع الفواتير',
      sandbox_mode: 'وضع Sandbox / اختبار', sandbox_desc: 'استخدام بيانات الاختبار بدلاً من البيانات الحية',
    },
    sms: {
      title: 'إعدادات الرسائل', subtitle: 'إعداد مزود خدمة الرسائل القصيرة',
      provider: 'مزود الرسائل', api_key: 'مفتاح API', sender_id: 'معرف المرسل',
      sender_id_desc: 'الاسم أو الرقم الذي يظهر كمرسل',
      enable_sms: 'تفعيل إشعارات الرسائل',
      enable_desc: 'إرسال رسائل لـ OTP والتذكيرات وتنبيهات التجديد',
    },
    landing: {
      contact_title: 'بيانات التواصل والتذييل',
      contact_subtitle: 'تظهر في الصفحة الرئيسية للزوار',
      social_title: 'روابط السوشيال ميديا',
      social_subtitle: 'اترك الحقل فارغاً لإخفاء الأيقونة من الموقع',
      modules_title: 'وحدات النظام',
      modules_subtitle: 'الوحدات الظاهرة في قسم «وحدات النظام» بالهوم بيج',
      company_name: 'اسم المنصة',
      phone: 'الهاتف',
      phone_desc: 'رقم الهاتف الظاهر في قسم التواصل',
      whatsapp: 'واتساب',
      whatsapp_desc: 'رقم واتساب مع مفتاح الدولة، مثال: 00201070205189',
      email: 'البريد الإلكتروني',
      address: 'العنوان',
      working_hours: 'ساعات العمل',
      footer_copyright: 'نص التذييل',
      footer_copyright_desc: 'نص حقوق النشر في أسفل الصفحة',
      facebook_url: 'فيسبوك',
      instagram_url: 'إنستغرام',
      twitter_url: 'إكس / تويتر',
      linkedin_url: 'لينكدإن',
      tiktok_url: 'تيك توك',
      youtube_url: 'يوتيوب',
      add_module: 'إضافة وحدة',
      module_label: 'اسم الوحدة',
      no_modules: 'لا توجد وحدات. أضف وحدة لتظهر في الهوم بيج.',
      loading: 'جاري تحميل إعدادات الصفحة الرئيسية…',
      saving: 'جاري الحفظ…',
      load_error: 'تعذر تحميل إعدادات الصفحة الرئيسية',
      save_error: 'تعذر حفظ إعدادات الصفحة الرئيسية',
    },
  },
  support: {
    new_ticket: 'تذكرة جديدة', reply: 'رد', close_ticket: 'إغلاق التذكرة',
    confirm_close: 'هل أنت متأكد من إغلاق هذه التذكرة؟ لن يُسمح بمزيد من الردود.',
    no_tickets: 'لا توجد تذاكر', tickets_count: 'تذكرة',
    filter: { all: 'الكل', open: 'مفتوحة', pending: 'معلقة', resolved: 'محلولة', closed: 'مغلقة' },
    search_placeholder: 'ابحث عن تذكرة...',
    priority: { low: 'منخفض', medium: 'متوسط', high: 'عالي', critical: 'حرج' },
    col: { id: 'التذكرة', atelier: 'الأتيليه', subject: 'الموضوع', priority: 'الأولوية', status: 'الحالة', created: 'تاريخ الإنشاء', actions: 'الإجراءات' },
    summary: { total: 'إجمالي التذاكر', open: 'مفتوحة', resolved: 'محلولة', closed: 'مغلقة' },
    reply_modal: {
      title: 'تفاصيل التذكرة', conversation: 'المحادثة',
      your_reply: 'ردك', reply_placeholder: 'اكتب ردك هنا...',
      send_reply: 'إرسال الرد', close_ticket: 'إغلاق التذكرة', admin: 'المسؤول',
    },
  },
  actions: {
    view: 'عرض', edit: 'تعديل', suspend: 'إيقاف', activate: 'تفعيل',
    login_as: 'الدخول كـ', delete: 'حذف', view_details: 'عرض التفاصيل',
    change_plan: 'تغيير الباقة', cancel: 'إلغاء', renew: 'تجديد',
    confirm: 'تأكيد', close: 'إغلاق',
  },
  status: {
    active: 'نشط', suspended: 'موقوف', pending: 'معلق', trial: 'تجريبي',
    cancelled: 'ملغي', expired: 'منتهي', approved: 'موافق', rejected: 'مرفوض',
    completed: 'مكتمل', paid: 'مدفوع', refunded: 'مسترجع', failed: 'فاشل',
    payment_submitted: 'بانتظار المراجعة',
  },
  coming_soon: {
    title: 'قريباً', badge: 'هذه الصفحة قيد التطوير',
    plans: 'إدارة باقات الأسعار والميزات',
    payments: 'تتبع وإدارة جميع المعاملات المالية',
    users: 'إدارة أعضاء الفريق وصلاحياتهم',
    admin_roles: 'تكوين الأدوار والصلاحيات للمسؤولين',
    settings: 'تكوين إعدادات النظام العامة',
    feature_flags: 'تفعيل وإيقاف الميزات حسب الباقة',
    support: 'إدارة والرد على تذاكر الدعم الفني',
    notifications: 'إرسال إشعارات جماعية للأتيليهات',
    logs: 'عرض سجلات نشاط ومراجعة النظام',
    integrations: 'ربط خدمات الطرف الثالث والواجهات البرمجية',
    marketing: 'إدارة الكوبونات والإحالات والتجارب المجانية',
  },
  users: {
    add_user: 'إضافة مسؤول',
    no_users: 'لا يوجد أعضاء في الفريق',
    users_count: 'عضو',
    confirm_delete: 'هل أنت متأكد من حذف هذا المسؤول؟ سيفقد جميع صلاحيات الوصول فوراً.',
    confirm_suspend: 'هل تريد إيقاف هذا المسؤول؟ سيفقد الوصول فوراً.',
    confirm_activate: 'هل تريد إعادة تفعيل حساب هذا المسؤول؟',
    filter: { all: 'الكل', active: 'نشط', suspended: 'موقوف' },
    search_placeholder: 'ابحث عن عضو...',
    col: { member: 'العضو', role: 'الدور', status: 'الحالة', last_login: 'آخر دخول', created: 'تاريخ الانضمام', actions: 'الإجراءات' },
    summary: { total: 'إجمالي المسؤولين', active: 'نشط', suspended: 'موقوف', roles: 'الأدوار المستخدمة' },
    roles: {
      super_admin: 'مسؤول عام', admin: 'مسؤول',
      support: 'وكيل دعم', finance: 'مالية', content: 'مدير محتوى',
    },
    role_desc: {
      super_admin: 'وصول كامل لجميع ميزات المنصة',
      admin: 'إدارة الأتيليهات والاشتراكات والمدفوعات',
      support: 'عرض والرد على تذاكر الدعم فقط',
      finance: 'الوصول للمدفوعات والفواتير والتقارير',
      content: 'إدارة الباقات والميزات والإشعارات',
    },
    form: {
      title_add: 'إضافة مسؤول جديد', title_edit: 'تعديل المسؤول',
      name: 'الاسم الكامل', name_placeholder: 'مثال: أحمد الراشدي',
      email: 'البريد الإلكتروني', email_placeholder: 'admin@dressnmore.sa',
      role: 'الدور', password: 'كلمة المرور', password_edit: 'كلمة المرور الجديدة',
      password_hint: 'اتركها فارغة للإبقاء على كلمة المرور الحالية',
      active: 'الحساب نشط', save: 'حفظ المسؤول', cancel: 'إلغاء',
    },
  },
  feature_flags: {
    save_all: 'حفظ التغييرات', saved: 'تم حفظ التغييرات!', unsaved: 'تغييرات غير محفوظة',
    search_placeholder: 'ابحث عن ميزة...',
    col: { feature: 'الميزة', category: 'الفئة', starter: 'ستارتر', pro: 'برو', enterprise: 'إنتربرايز' },
    categories: { core: 'الميزات الأساسية', advanced: 'الميزات المتقدمة', integrations: 'التكاملات', beta: 'ميزات بيتا' },
    no_flags: 'لا توجد ميزات', flags_count: 'ميزة', beta_badge: 'بيتا',
    summary: { total: 'إجمالي الميزات', enabled_all: 'مفعّل بالكامل', partial: 'مفعّل جزئياً', beta_count: 'ميزات بيتا' },
  },
  admin_roles: {
    add_role: 'إضافة دور', no_roles: 'لا توجد أدوار محددة',
    confirm_delete: 'حذف هذا الدور؟ سيفقد المستخدمون المعيّنون له صلاحياتهم.',
    system_role: 'دور النظام', system_role_desc: 'لا يمكن تعديله أو حذفه',
    users_using: 'مستخدمون', permissions_count: 'صلاحية',
    all_permissions: 'صلاحية كاملة',
    select_all: 'الكل', deselect_all: 'لا شيء',
    groups: {
      dashboard: 'لوحة التحكم', ateliers: 'الأتيليهات', subscriptions: 'الاشتراكات',
      order_plans: 'طلبات الباقات', demo_tenants: 'الحسابات التجريبية', payments: 'المدفوعات', payment_gateways: 'بوابات الدفع',
      plans: 'الباقات', flags: 'إعدادات الميزات',
      support: 'الدعم الفني', users: 'المستخدمون', admin_roles: 'أدوار المسؤولين', reports: 'التقارير',
      settings: 'الإعدادات', notifs: 'الإشعارات', contact_messages: 'الرسائل', recruitment: 'التوظيف', logs: 'السجلات',
      marketing: 'التسويق', integrations: 'التكاملات', ai_sales: 'وكيل المبيعات الذكي',
    },
    perms: {
      view_dashboard: 'عرض لوحة التحكم',
      view_ateliers: 'عرض الأتيليهات', add_atelier: 'إضافة أتيليه', edit_atelier: 'تعديل أتيليه', suspend_atelier: 'إيقاف أتيليه', delete_atelier: 'حذف أتيليه', login_as_atelier: 'الدخول كأتيليه',
      view_subscriptions: 'عرض الاشتراكات', edit_subscription: 'تعديل اشتراك', cancel_subscription: 'إلغاء اشتراك', renew_subscription: 'تجديد اشتراك',
      view_order_plans: 'عرض طلبات الباقات', approve_order_plan: 'الموافقة على طلب باقة', reject_order_plan: 'رفض طلب باقة', delete_order_plan: 'حذف طلب باقة',
      view_demo_tenants: 'عرض الحسابات التجريبية', add_demo_tenant: 'إضافة حساب تجريبي',
      view_payments: 'عرض المدفوعات', refund_payment: 'استرجاع دفعة', mark_paid: 'تحديد كمدفوع',
      view_payment_gateways: 'عرض بوابات الدفع', add_payment_gateway: 'إضافة بوابة دفع', edit_payment_gateway: 'تعديل بوابة دفع', delete_payment_gateway: 'حذف بوابة دفع',
      view_plans: 'عرض الباقات', add_plan: 'إضافة باقة', edit_plan: 'تعديل باقة', delete_plan: 'حذف باقة',
      view_flags: 'عرض إعدادات الميزات', edit_flags: 'تعديل إعدادات الميزات',
      view_tickets: 'عرض التذاكر', reply_ticket: 'الرد على تذكرة', close_ticket: 'إغلاق تذكرة',
      view_users: 'عرض المستخدمين', add_user: 'إضافة مستخدم', edit_user: 'تعديل مستخدم', delete_user: 'حذف مستخدم',
      view_admin_roles: 'عرض الأدوار', add_admin_role: 'إضافة دور', edit_admin_role: 'تعديل دور', delete_admin_role: 'حذف دور',
      view_reports: 'عرض التقارير', export_reports: 'تصدير التقارير',
      view_settings: 'عرض الإعدادات', edit_settings: 'تعديل الإعدادات',
      view_notifications: 'عرض الإشعارات', send_notifications: 'إرسال الإشعارات',
      view_contact_messages: 'عرض رسائل التواصل',
      view_recruitment: 'عرض التوظيف',
      manage_recruitment_jobs: 'إدارة الوظائف',
      manage_recruitment_applications: 'إدارة طلبات التوظيف',
      manage_recruitment_settings: 'إعدادات التوظيف',
      view_logs: 'عرض السجلات',
      view_marketing: 'عرض التسويق', edit_marketing: 'تعديل التسويق',
      view_integrations: 'عرض التكاملات',
      'ai_sales.view': 'عرض وكيل المبيعات الذكي',
      'ai_sales.inbox': 'صندوق محادثات المبيعات',
      'ai_sales.leads': 'عملاء وكيل المبيعات',
      'ai_sales.followups': 'متابعات وكيل المبيعات',
      'ai_sales.knowledge': 'قاعدة معرفة المبيعات',
      'ai_sales.agent': 'إعدادات وكيل المبيعات',
      'ai_sales.analytics': 'تحليلات وكيل المبيعات',
      'ai_sales.manage': 'إدارة وكيل المبيعات',
    },
    form: {
      title_add: 'إنشاء دور جديد', title_edit: 'تعديل الدور',
      name: 'اسم الدور', name_placeholder: 'مثال: مدير الفوترة',
      description: 'الوصف', description_placeholder: 'ماذا يستطيع هذا الدور أن يفعل؟',
      color: 'لون الدور', permissions_title: 'الصلاحيات',
      save: 'حفظ الدور', cancel: 'إلغاء',
    },
  },
  notifications: {
    send: 'إرسال الإشعار', sending: 'جارٍ الإرسال...', sent_success: 'تم إرسال الإشعار بنجاح!',
    compose: { title: 'إنشاء إشعار', subtitle: 'إرسال بث لأتيليهاتك' },
    history_title: 'سجل الإشعارات',
    target: { label: 'الجمهور المستهدف', all: 'جميع الأتيليهات', by_plan: 'حسب الباقة', by_status: 'حسب الحالة' },
    channels: { label: 'القنوات', inapp: 'داخل التطبيق', email: 'بريد إلكتروني', sms: 'رسالة SMS' },
    fields: { title: 'العنوان', title_placeholder: 'عنوان الإشعار...', message: 'الرسالة', message_placeholder: 'اكتب رسالتك هنا...' },
    col: { title: 'العنوان', target: 'الجمهور', channels: 'القنوات', sent: 'أُرسل إلى', opened: 'فُتح من قِبل', date: 'التاريخ', status: 'الحالة' },
    filter: { all: 'الكل', sent: 'مُرسل', scheduled: 'مجدول', draft: 'مسودة', failed: 'فاشل' },
    no_notifications: 'لم يُرسل أي إشعار بعد',
    notifs_count: 'إشعار',
    status: { sent: 'مُرسل', scheduled: 'مجدول', draft: 'مسودة', failed: 'فاشل', partial: 'جزئي' },
    summary: { total_sent: 'إجمالي المُرسل', avg_open: 'متوسط معدل الفتح', last_7: 'آخر 7 أيام', today: 'اليوم', delivered: 'تسليم للأتيليهات' },
    preview: 'معاينة',
    chars_remaining: 'حرف متبقي',
  },
  messages: {
    mark_all_read: 'تعليم الكل كمقروء',
    refresh: 'تحديث',
    search: 'بحث',
    search_placeholder: 'ابحث بالاسم أو البريد أو الرسالة...',
    loading: 'جارٍ التحميل...',
    empty: 'لا توجد رسائل بعد',
    unread: 'جديدة',
    read: 'مقروءة',
    detail_hint: 'اختر رسالة لعرض التفاصيل',
    filter: { all: 'كل الرسائل', unread: 'غير المقروءة', read: 'المقروءة' },
    summary: {
      total: 'المعروضة',
      unread: 'غير مقروءة',
      source: 'المصدر',
      source_value: 'نموذج التواصل — الصفحة الرئيسية',
    },
    col: {
      status: 'الحالة',
      name: 'الاسم',
      email: 'البريد',
      phone: 'الهاتف',
      atelier: 'الأتيليه',
      message: 'الرسالة',
      date: 'التاريخ',
    },
  },
  marketing: {
    tabs: { coupons: 'الكوبونات', referrals: 'الإحالات', trials: 'التجارب المجانية' },
    coupons: {
      add_coupon: 'إضافة كوبون', no_coupons: 'لا توجد كوبونات', coupons_count: 'كوبون',
      copy_code: 'نسخ', copied: 'تم النسخ!',
      confirm_delete: 'حذف هذا الكوبون؟ ستُحذف جميع الاستخدامات المرتبطة به.',
      confirm_toggle: 'تغيير حالة هذا الكوبون؟',
      types: { percentage: 'نسبة مئوية', fixed: 'مبلغ ثابت' },
      plan: { all: 'جميع الباقات', starter: 'ستارتر', pro: 'برو', enterprise: 'إنتربرايز' },
      filter: { all: 'الكل', active: 'نشط', inactive: 'غير نشط', expired: 'منتهي' },
      search_placeholder: 'ابحث عن كوبون...',
      col: { code: 'الكود', type: 'النوع', value: 'القيمة', usage: 'الاستخدام', plan: 'الباقة', status: 'الحالة', expires: 'انتهاء الصلاحية', actions: 'الإجراءات' },
      summary: { total: 'إجمالي الكوبونات', active: 'نشطة', uses: 'إجمالي الاستخدامات', savings: 'إجمالي الخصومات' },
      form: {
        title_add: 'إضافة كوبون جديد', title_edit: 'تعديل الكوبون',
        code: 'كود الكوبون', code_placeholder: 'مثال: SUMMER25', generate: 'توليد',
        type: 'نوع الخصم', value: 'قيمة الخصم', value_placeholder: 'مثال: 25',
        max_uses: 'الحد الأقصى للاستخدام', max_uses_hint: '0 = غير محدود',
        target_plan: 'الباقة المستهدفة', expiry: 'تاريخ انتهاء الصلاحية',
        active: 'الكوبون نشط', save: 'حفظ الكوبون', cancel: 'إلغاء',
      },
    },
    referrals: {
      no_referrals: 'لا توجد إحالات', referrals_count: 'محيل',
      commission_settings: 'إعدادات العمولة',
      commission_rate_label: 'عمولة لكل تحويل',
      commission_placeholder: '% أو مبلغ ثابت',
      search_placeholder: 'ابحث عن محيل...',
      filter: { all: 'الكل', active: 'نشط', paused: 'موقوف' },
      col: { referrer: 'المحيل', code: 'كود الإحالة', referred: 'المُحالون', converted: 'محوّلون', earned: 'العمولة', joined: 'تاريخ الانضمام', status: 'الحالة', actions: 'الإجراءات' },
      summary: { total: 'إجمالي المُحالون', active: 'محيلون نشطون', converted: 'محوّلون', commission: 'إجمالي العمولات' },
      confirm_pause: 'إيقاف هذا المحيل؟ لن يكسب عمولات جديدة.',
      confirm_activate: 'إعادة تفعيل هذا المحيل؟',
    },
    trials: {
      grant_trial: 'منح تجربة', no_trials: 'لا توجد تجارب مجانية', trials_count: 'تجربة',
      days_remaining: 'يوم متبقي', expired_label: 'منتهية',
      filter: { all: 'الكل', active: 'نشطة', expired: 'منتهية', converted: 'محوّلة', cancelled: 'ملغاة' },
      search_placeholder: 'ابحث عن أتيليه...',
      col: { atelier: 'الأتيليه', plan: 'الباقة', start: 'البداية', end: 'النهاية', days: 'المتبقي', status: 'الحالة', actions: 'الإجراءات' },
      summary: { active: 'تجارب نشطة', expired: 'منتهية', converted: 'محوّلة', rate: 'معدل التحويل' },
      extend: 'تمديد', convert: 'تحويل لمدفوع', cancel_trial: 'إلغاء التجربة',
      confirm_convert: 'تحويل تجربة هذا الأتيليه إلى اشتراك مدفوع؟',
      confirm_cancel: 'إلغاء هذه التجربة المجانية؟ سيفقد الأتيليه الوصول.',
      extend_modal: { title: 'تمديد التجربة المجانية', days_label: 'أيام إضافية', save: 'تمديد التجربة', cancel: 'إلغاء' },
    },
  },
  logs: {
    export: 'تصدير CSV', no_logs: 'لا توجد سجلات', logs_count: 'سجل',
    search_placeholder: 'ابحث في السجلات...',
    time: { all: 'كل الوقت', today: 'اليوم', week: '7 أيام', month: '30 يوم' },
    filter: { all_types: 'كل الأنواع', all_users: 'كل المستخدمين' },
    types: { auth: 'مصادقة', atelier: 'أتيليه', payment: 'دفع', settings: 'إعدادات', system: 'النظام', error: 'خطأ', support: 'دعم' },
    severity: { info: 'معلومة', warning: 'تحذير', error: 'خطأ', success: 'نجاح' },
    col: { time: 'الوقت', type: 'النوع', severity: 'الشدة', action: 'الإجراء', user: 'المسؤول', ip: 'عنوان IP' },
    summary: { total: 'إجمالي الأحداث', errors: 'الأخطاء', warnings: 'التحذيرات', today: 'اليوم' },
  },
  profile: {
    info_title: 'البيانات الأساسية',
    info_subtitle: 'حدّث اسمك وبريدك ورقم هاتفك',
    password_title: 'تغيير كلمة المرور',
    password_subtitle: 'استخدم كلمة مرور قوية لا تقل عن 8 أحرف',
    current_password: 'كلمة المرور الحالية',
    new_password: 'كلمة المرور الجديدة',
    confirm_password: 'تأكيد كلمة المرور',
    save: 'حفظ التغييرات',
    change_password: 'تحديث كلمة المرور',
    name: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    phone_hint: 'اختياري — للتواصل السريع',
    last_login: 'آخر دخول',
    joined: 'تاريخ الانضمام',
    status_active: 'نشط',
    status_suspended: 'موقوف',
    change_avatar: 'تغيير الصورة',
    remove_avatar: 'حذف الصورة',
    saved: 'تم حفظ الملف الشخصي بنجاح',
    save_failed: 'تعذر حفظ الملف الشخصي',
    validation_required: 'الاسم والبريد مطلوبان',
    password_required: 'أكمل جميع حقول كلمة المرور',
    password_min: 'كلمة المرور يجب ألا تقل عن 8 أحرف',
    password_mismatch: 'تأكيد كلمة المرور غير متطابق',
    password_changed: 'تم تغيير كلمة المرور بنجاح',
    password_failed: 'تعذر تغيير كلمة المرور',
    avatar_saved: 'تم تحديث الصورة الشخصية',
    avatar_removed: 'تم حذف الصورة الشخصية',
    avatar_failed: 'تعذر تحديث الصورة',
    avatar_invalid: 'الملف يجب أن يكون صورة',
    avatar_too_large: 'حجم الصورة يجب ألا يتجاوز 5 ميجابايت',
  },
  login: {
    title: 'مرحباً بعودتك', subtitle: 'سجّل دخولك إلى لوحة التحكم',
    email: 'البريد الإلكتروني', email_placeholder: 'admin@dressnmore.sa',
    password: 'كلمة المرور', password_placeholder: 'أدخل كلمة المرور',
    submit: 'تسجيل الدخول', submitting: 'جارٍ تسجيل الدخول...',
    error: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    brand_title: 'مركز التحكم الإداري',
    brand_desc: 'أدر منصة Dressnmore SaaS بالكامل من لوحة تحكم واحدة.',
    features: {
      f1: 'نظرة شاملة على المنصة', f2: 'تحليلات وتقارير فورية', f3: 'إدارة أتيليهات متعددة',
    },
  },
  payment_gateways: {
    add_gateway: 'إضافة بوابة دفع',
    no_gateways: 'لا توجد بوابات دفع',
    gateways_count: 'بوابة',
    confirm_delete: 'حذف هذه البوابة؟ لا يمكن التراجع عن هذا الإجراء.',
    confirm_toggle_on: 'تفعيل بوابة الدفع هذه؟',
    confirm_toggle_off: 'إيقاف بوابة الدفع هذه؟ لن تظهر للأتيليهات.',
    copy_number: 'نسخ',
    copied: 'تم النسخ!',
    filter: { all: 'الكل', active: 'نشطة', inactive: 'غير نشطة' },
    search_placeholder: 'ابحث عن بوابة دفع...',
    types: {
      bank: 'تحويل بنكي',
      vodafone_cash: 'فودافون كاش',
      instapay: 'انستاباي',
      orange_cash: 'أورنج كاش',
      etisalat_cash: 'اتصالات كاش',
      fawry: 'فوري',
      other: 'أخرى',
    },
    labels: {
      account_holder: 'اسم صاحب الحساب',
      account_number: 'رقم الحساب / الهاتف',
      bank_name: 'اسم البنك',
      iban: 'رقم الآيبان',
      instructions: 'تفاصيل وتعليمات الدفع',
      usage: 'عدد مرات الاستخدام',
      display_order: 'ترتيب العرض',
    },
    summary: {
      total: 'إجمالي البوابات',
      active: 'نشطة',
      inactive: 'غير نشطة',
      types_count: 'أنواع البوابات',
    },
    form: {
      title_add: 'إضافة بوابة دفع جديدة',
      title_edit: 'تعديل بوابة الدفع',
      name: 'اسم البوابة',
      name_placeholder: 'مثال: البنك الأهلي السعودي',
      type: 'نوع البوابة',
      account_holder: 'اسم صاحب الحساب',
      account_holder_placeholder: 'مثال: شركة درسن مور للتقنية',
      account_number: 'رقم الحساب / الهاتف',
      account_number_placeholder: 'مثال: 01012345678',
      bank_name: 'اسم البنك',
      bank_name_placeholder: 'مثال: البنك الأهلي السعودي',
      iban: 'رقم الآيبان (اختياري)',
      iban_placeholder: 'SA12 1000 0000 ...',
      instructions: 'تفاصيل وتعليمات الدفع',
      instructions_placeholder: 'اشرح للعملاء كيفية الدفع وإرسال إيصال التحويل...',
      display_order: 'ترتيب العرض',
      active: 'البوابة نشطة',
      save: 'حفظ البوابة',
      cancel: 'إلغاء',
    },
  },
  recruitment: {
    loading: 'جاري التحميل…',
    saving: 'جارٍ الحفظ…',
    save: 'حفظ',
    cancel: 'إلغاء',
    refresh: 'تحديث',
    back: 'العودة للطلبات',
    today: 'اليوم',
    filter: { all: 'الكل' },
    job_status: { draft: 'مسودة', published: 'منشورة', closed: 'مغلقة', archived: 'مؤرشفة' },
    app_status: {
      new: 'جديد', screening: 'فرز', shortlisted: 'مختصر', interview: 'مقابلة',
      final_review: 'مراجعة نهائية', accepted: 'مقبول', rejected: 'مرفوض',
    },
    employment: { full_time: 'دوام كامل', part_time: 'دوام جزئي', contract: 'عقد', internship: 'تدريب' },
    jobs: {
      add: 'وظيفة جديدة', edit: 'تعديل الوظيفة', search: 'ابحث عن وظيفة…', empty: 'لا توجد وظائف بعد',
      publish: 'نشر', hide: 'إخفاء', close: 'إغلاق', archive: 'أرشفة',
      confirm_delete: 'حذف هذه الوظيفة؟',
      col: { title: 'المسمى', department: 'القسم', location: 'الموقع', status: 'الحالة', apps: 'الطلبات' },
      fields: {
        title: 'المسمى الوظيفي', slug: 'المسار', department: 'القسم', employment_type: 'نوع التوظيف',
        location: 'الموقع', status: 'الحالة', description: 'عن الدور',
        responsibilities: 'ماذا ستفعل؟', requirements: 'نبحث عن', nice_to_have: 'سيكون رائعاً لو لديك',
        benefits: 'ماذا نقدم؟', skills: 'المهارات', list_hint: 'سطر لكل نقطة',
      },
    },
    applications: {
      search: 'ابحث عن مرشح…', empty: 'لا توجد طلبات', general: 'طلب عام',
      years: '{{count}} سنوات',
      col: { candidate: 'المرشح', job: 'الوظيفة', experience: 'الخبرة', date: 'التاريخ', status: 'الحالة', email: 'البريد', phone: 'الهاتف', city: 'المدينة' },
    },
    summary: { total: 'الإجمالي' },
    pipeline: { title: 'مسار التوظيف' },
    notes: { title: 'ملاحظات الفريق', placeholder: 'ملاحظة داخلية…', add: 'إضافة ملاحظة' },
    timeline: { title: 'الجدول الزمني' },
    cv: { view: 'عرض السيرة', download: 'تنزيل' },
    settings: {
      notify_email: 'بريد تنبيه الفريق',
      accepting: 'استقبال الطلبات مفتوح',
      honeypot: 'تفعيل الحماية من الرسائل المزعجة',
      cv_max: 'الحد الأقصى لحجم السيرة (كيلوبايت)',
      saved: 'تم حفظ الإعدادات',
    },
  },
  // Credentials Popup Translations
  credentials: {
    popup: {
      title: 'بيانات اعتماد المدير',
      subtitle: 'احفظ هذه البيانات الآن — وأُرسلت أيضاً لبريد العميل',
      email: 'البريد الإلكتروني',
      password: 'كلمة السر',
      copy: 'نسخ إلى الحافظة',
      copy_all: 'نسخ الكل',
      close: 'إغلاق',
      warning: 'تظهر كلمة السر هذه مرة واحدة فقط. يرجى حفظها بشكل آمن لأنه لا يمكن استرجاعها لاحقاً.',
      tenant: 'اسم المستأجر',
      workspace: 'معرّف مساحة العمل',
      login_url: 'رابط الدخول',
      next_steps: 'روابط سريعة بعد التفعيل',
      open_atelier: 'الأتيليه',
      open_subscription: 'الاشتراك',
      open_payments: 'المدفوعات',
    },
  },
};

export default ar;